import {
  IGetMarketChartLatestParams,
  IGetMarketChartsParams,
  IGetMarketLiveChartsParams,
  IGetPriceLadderParams,
  ILatestChartTime,
  IMarketChartData,
  IPriceLadder
} from '@aqx-core/common/api/chart';
import { request } from '@aqx-core/common/request';

export default {
  priceLadder: (params: IGetPriceLadderParams, signal: AbortSignal) =>
    request.get<IPriceLadder>('/api/chart/v1/ladder', { params, signal }),
  historicalChart: (params: IGetMarketChartsParams, signal?: AbortSignal) =>
    request.get<IMarketChartData[]>('/api/chart/v4/candlestick', {
      params,
      signal
    }),
  latestBarData: (params: IGetMarketLiveChartsParams, signal?: AbortSignal) =>
    request.get<IMarketChartData>('/api/chart/v2/candlestick/latest', {
      params,
      signal
    }),
  latest: (params: IGetMarketChartLatestParams, signal?: AbortSignal) =>
    request.get<ILatestChartTime>('/api/chart/v2/price/latest', {
      params,
      signal
    })
};
